/**
 * 请求地址配置 JS
 * @Author 吴成林
 * @Date 2022-1-10 17:29:35
 */
const UrlConfig = {
  /**
   *  会员登录
   * @Author 吴成林
   * @Date 2022-1-10 17:30:40
   */
  auth_member_accredit: '/auth/member/accredit',

  /**
   *  会员详情
   * @Author 吴成林
   * @Date 2022-1-10 17:30:40
   */
  member_member_detailsPageMember: '/member/member/detailsPageMember',


};

export default UrlConfig;



// WEBPACK FOOTER //
// ./src/tool/UrlConfig.js